import { v4 as uuidv4 } from "uuid";

export const COOKIE_SESSION_ID_KEY = "browserSessionId";
export const SESSION_STORAGE_KEY = "sessionId";
export const COOKIE_PATH = "/";

export const newBrowserSessionId = () => {
  return uuidv4();
};
